var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-full flex align-center"},[_c('div',{staticClass:"tc"},[_c('icon',{attrs:{"icon":"spinner","spin":""}}),_c('p',[_vm._v(" "+_vm._s(_vm.status)+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }